import { useCallback, useEffect, useRef, useState } from 'react';
import { learningApi } from '../api/learning';
import type { VocabularyLibraryPage } from '../types/api';

export function useVocabularyLibrary(enabled: boolean, query: string, status: string, page: number, refreshKey: number) {
  const [data, setData] = useState<VocabularyLibraryPage | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const requestSequence = useRef(0);
  const limit = 30;

  const refresh = useCallback(async () => {
    if (!enabled) return;
    const requestId = ++requestSequence.current;
    setLoading(true);
    try {
      const next = await learningApi.vocabularyLibrary(page * limit, limit, query, status);
      if (requestId !== requestSequence.current) return;
      setData(next);
      setError(null);
    } catch {
      if (requestId === requestSequence.current) setError('Kunne ikke hente ordbiblioteket.');
    } finally {
      if (requestId === requestSequence.current) setLoading(false);
    }
  }, [enabled, page, query, status]);

  useEffect(() => {
    requestSequence.current += 1;
    const timer = window.setTimeout(() => void refresh(), query ? 250 : 0);
    return () => window.clearTimeout(timer);
  }, [refresh, refreshKey, query]);

  return { data, loading, error, refresh, limit };
}
